import React from "react";
import FlxdeckHeader from "./FlxdeckHeader";
import Workout from "../../common/Workout/Workout.js";
import "./style.css";

const FlxdeckWorkout = () => {
  return (
    <div className="flxdeck">
      <FlxdeckHeader />
      <Workout />
    </div>
  );
};

export default FlxdeckWorkout;
